import { useTranslation } from 'react-i18next'

import Button from '@/components/Button/Button'
import { BaseModal } from '@/components/Modal/Modal'
import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'
import type { IdAndName } from '@/types/id-and-name'

import styles from './BulkActionModal.module.scss'
import UnableToPerfomAction from './UnableToPerfomAction'

type CommonProps = {
  open: boolean
  onOpenChange: (open: boolean) => void

  unableToPerformActionData: IdAndName[]
  count: number
  page: number
  isTableLoading?: boolean
  pageSize?: number
  onPageChange: (page: number) => void

  title: string
  description: React.ReactNode
  alertTitle: React.ReactNode
  alertDescription: React.ReactNode
}

type PropsWithConfirmButtonNode = CommonProps & {
  confirmButton: React.ReactNode
}

type PropsWithConfirmButtonActions = CommonProps & {
  onConfirm: () => void
  isConfirmLoading?: boolean
  confirmText?: string
}

type BulkActionModalProps =
  | PropsWithConfirmButtonNode
  | PropsWithConfirmButtonActions

const BulkActionModal = (props: BulkActionModalProps) => {
  const { t } = useTranslation('common')
  const { pageSize = DEFAULT_PAGE_SIZE } = props

  const isAnyUnableToPerformAction = props.count > 0

  const modalSize = isAnyUnableToPerformAction ? 'sm' : 'xs'

  return (
    <BaseModal
      size={modalSize}
      open={props.open}
      onOpenChange={props.onOpenChange}
      title={props.title}
      hideCloseIcon
      contentClassName={styles.modal}
    >
      <div className={styles.content}>
        <div className={styles.description}>{props.description}</div>
        <UnableToPerfomAction {...props} pageSize={pageSize} />
        <footer className={styles.footer}>
          <Button variant="tertiary" onClick={() => props.onOpenChange(false)}>
            {t('button.cancel')}
          </Button>
          {'confirmButton' in props ? (
            props.confirmButton
          ) : (
            <Button
              variant="danger"
              onClick={props.onConfirm}
              loading={props.isConfirmLoading}
            >
              {props.confirmText ?? t('button.confirm')}
            </Button>
          )}
        </footer>
      </div>
    </BaseModal>
  )
}

export default BulkActionModal
